import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { getUserOnboardingAsync, createUserOnboardingAsync, verifyAPIKeyAsync, createUserSubscriptionAsync } from './index';

const initialState = {
    userOnboardingData: null,
    isOnboardingLoading: false,
    isOnboardingCompleted: false,
    isError: false,
    isAPIKeyVerifiedLoading: false,
    isAPIKeyVerified: false,
    apiKey: '',
    isUserSubscriptionLoading: false,
    isUserSubscriptionError: false,
    isSubscription: false,
}

const userOnboardingSlice = createSlice({
    name: 'userOnboarding',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserOnboardingAsync.pending, (state) => {
                state.isOnboardingLoading = true;
            })
            .addCase(getUserOnboardingAsync.fulfilled, (state, { payload }) => {
                state.isOnboardingLoading = false;
                if (payload) {
                    state.userOnboardingData = payload?.data;
                    state.apiKey = payload?.apiKey;
                    state.isAPIKeyVerified = payload?.apiKey ? true : false;
                    state.isSubscription = payload?.isSubscription;
                }
            })
            .addCase(getUserOnboardingAsync.rejected, (state) => {
                state.isOnboardingLoading = false;
                state.isError = false;
                state.userOnboardingData = null;
                state.apiKey = '';
                state.isAPIKeyVerified = false;
                state.isSubscription = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(createUserOnboardingAsync.pending, (state) => {
                state.isOnboardingLoading = true;
            })
            .addCase(createUserOnboardingAsync.rejected, (state) => {
                state.isOnboardingLoading = false;
                state.isError = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(verifyAPIKeyAsync.pending, (state) => {
                state.isAPIKeyVerifiedLoading = true;
            })
            .addCase(verifyAPIKeyAsync.fulfilled, (state, { payload }) => {
                state.isAPIKeyVerifiedLoading = false;
                if (payload) {
                    state.isAPIKeyVerified = state.apiKey === '' ? payload?.success : true;
                    if (payload?.data?.apiKey) {
                        state.apiKey = payload?.data?.apiKey;
                    }
                }
            })
            .addCase(verifyAPIKeyAsync.rejected, (state) => {
                state.isAPIKeyVerifiedLoading = false;
                state.isAPIKeyVerified = false;
            })
            .addCase(createUserSubscriptionAsync.pending, (state) => {
                state.isUserSubscriptionLoading = true;
            })
            .addCase(createUserSubscriptionAsync.fulfilled, (state, { payload }) => {
                if (payload) {
                    window.top.location.href = payload;
                }
                // state.isUserSubscriptionLoading = false;
            })
            .addCase(createUserSubscriptionAsync.rejected, (state) => {
                state.isUserSubscriptionLoading = false;
                state.isUserSubscriptionError = true;
            })
    },
});

export const getAllUserOnboarding = (state) => state.userOnboarding;

export default userOnboardingSlice.reducer;
